/* eslint-disable */
export default {
  removeMeetingWarning:
    'La fonctionnalité de planification a été supprimée. Veuillez utiliser l’application {app} pour planifier vos réunions vidéo.',
  scheduleMeetingTips:
    'Veuillez noter que nous avons retiré les réunions de cette application. Pour utiliser les réunions, nous recommandons l’application {app}.',
  migrateToPluginAlert:
    'Remarque : Cette application ne fonctionne pas avec Outlook 2016 ou une version antérieure, ni avec Internet Explorer 11. Veuillez mettre votre Outlook à niveau ou passer à Microsoft Edge, ou encore passer à {app}',
} as const;

// @key: @#@"removeMeetingWarning"@#@ @source: @#@"The scheduling feature is discontinued. Please use the {app} to schedule your video meetings."@#@
// @key: @#@"scheduleMeetingTips"@#@ @source: @#@"Please note that we removed meetings from this app. To use meetings, we recommend the {app}."@#@
// @key: @#@"migrateToPluginAlert"@#@ @source: @#@"Note: This app will not work with Outlook version 2016 and below and Internet Explorer 11. Please upgrade your Outlook or switch to Microsoft Edge, or alternately, switch to {app}"@#@
